// extracted by mini-css-extract-plugin
export var root = "MarkdownLI-module--root--d3fdc";